import React from "react";
import "./Card4.css";
const Card3 = (props) => {
  return (
    <div>
      <div className="card4">
        <div className="above2">
          <img src={props.image} alt="" />
        </div>

        <div className="content3">
          <div className="admin">
            <div className="admin-img">
              <img
                src="https://img.freepik.com/free-photo/fashion-boy-with-yellow-jacket-blue-pants_71767-96.jpg?size=626&ext=jpg&ga=GA1.1.591747197.1690133839&semt=sph"
                alt=""
              />
            </div>
            <div className="admin-content">
              <span>Admin</span>
              <span>21 march</span>
            </div>
          </div>
          <h1>{props.Title}</h1>
          <p>{props.Content.substr(0, 300) + "....."}</p>
        </div>
      </div>
    </div>
  );
};

export default Card3;
